/**
 * @generated SignedSource<<e5d8f9e775d507b6573c5867fdd6d922>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyOrdering = "created_at_desc" | "total_streams_desc";
export type CompanyServiceFilter = "CONTENT_PRODUCTION" | "DISTRIBUTION" | "FUNDING" | "INDUSTRY" | "INFLUENCER" | "MARKETING";
export type FundDirectoryPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  displayName_Icontains?: string | null;
  genres?: ReadonlyArray<string | null> | null;
  onlyWatching?: boolean | null;
  onlyWithTestimonials?: boolean | null;
  orderBy?: CompanyOrdering | null;
  services?: ReadonlyArray<CompanyServiceFilter | null> | null;
};
export type FundDirectoryPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FundDirectoryRows_allCompanies">;
};
export type FundDirectoryPaginationQuery = {
  response: FundDirectoryPaginationQuery$data;
  variables: FundDirectoryPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "displayName_Icontains"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "genres"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "onlyWatching"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlyWithTestimonials"
  },
  {
    "defaultValue": "total_streams_desc",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "services"
  }
],
v1 = {
  "kind": "Variable",
  "name": "displayName_Icontains",
  "variableName": "displayName_Icontains"
},
v2 = {
  "kind": "Variable",
  "name": "genres",
  "variableName": "genres"
},
v3 = {
  "kind": "Variable",
  "name": "onlyWatching",
  "variableName": "onlyWatching"
},
v4 = {
  "kind": "Variable",
  "name": "onlyWithTestimonials",
  "variableName": "onlyWithTestimonials"
},
v5 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v6 = {
  "kind": "Variable",
  "name": "services",
  "variableName": "services"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FundDirectoryPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "FundDirectoryRows_allCompanies"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FundDirectoryPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CompanyNodeConnection",
        "kind": "LinkedField",
        "name": "allCompanies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalStreams",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ranked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watching",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerNode",
                    "kind": "LinkedField",
                    "name": "recipientPartner",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChatNode",
                            "kind": "LinkedField",
                            "name": "chatWithCurrentUser",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerHasMessaged",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "artistHasMessaged",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isActorInterface"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerNodeConnection",
                    "kind": "LinkedField",
                    "name": "partners",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastActiveAt",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistNode",
                    "kind": "LinkedField",
                    "name": "artistsBacked",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "spotifyProfile",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyServiceNodeConnection",
                    "kind": "LinkedField",
                    "name": "services",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyServiceNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyServiceNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "service",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*: any*/),
        "filters": [
          "orderBy",
          "displayName_Icontains",
          "onlyWatching",
          "onlyWithTestimonials",
          "services",
          "genres"
        ],
        "handle": "connection",
        "key": "FundDirectory_allCompanies",
        "kind": "LinkedHandle",
        "name": "allCompanies"
      }
    ]
  },
  "params": {
    "cacheID": "0f41787af531bda24c39ec4534281e0b",
    "id": null,
    "metadata": {},
    "name": "FundDirectoryPaginationQuery",
    "operationKind": "query",
    "text": "query FundDirectoryPaginationQuery(\n  $count: Int = 25\n  $cursor: String\n  $displayName_Icontains: String = \"\"\n  $genres: [ID]\n  $onlyWatching: Boolean = false\n  $onlyWithTestimonials: Boolean\n  $orderBy: CompanyOrdering = total_streams_desc\n  $services: [CompanyServiceFilter]\n) {\n  ...FundDirectoryRows_allCompanies_2SySIJ\n}\n\nfragment FundDirectoryRows_allCompanies_2SySIJ on Query {\n  allCompanies(first: $count, after: $cursor, orderBy: $orderBy, displayName_Icontains: $displayName_Icontains, onlyWatching: $onlyWatching, onlyWithTestimonials: $onlyWithTestimonials, services: $services, genres: $genres) {\n    edges {\n      node {\n        id\n        ...RowFund_fund\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MultipleArtists_artists on ArtistNode {\n  id\n  displayName\n  ...useArtistThumbnailUrl_artist\n}\n\nfragment RowFund_fund on CompanyNode {\n  displayName\n  slug\n  ...useToggleWatchCompany_company\n  thumbnailUrl\n  totalStreams\n  ranked\n  watching\n  recipientPartner {\n    user {\n      chatWithCurrentUser {\n        ...useArtistCanMessageCompany_chat\n        id\n      }\n      id\n    }\n    id\n    ...useMessage_actor\n  }\n  partners {\n    edges {\n      node {\n        user {\n          lastActiveAt\n          id\n        }\n        id\n      }\n    }\n  }\n  artistsBacked {\n    ...MultipleArtists_artists\n    id\n  }\n  services {\n    edges {\n      node {\n        service\n        id\n      }\n    }\n  }\n}\n\nfragment useArtistCanMessageCompany_chat on ChatNode {\n  partnerHasMessaged\n  artistHasMessaged\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n\nfragment useToggleWatchCompany_company on CompanyNode {\n  slug\n}\n"
  }
};
})();

(node as any).hash = "f8a304cf26125288cf82f5e5449e3ebd";

export default node;
